<template>
    <div>
        <v-card  flat>
			<v-card-title>
				{{ $t("chart_of_accounts") }}
				<v-spacer></v-spacer>
				<!-- <v-btn 
					v-if="selected.chart.length"
                    class="mx-1"
                    icon>
                    <v-icon>mdi-eye</v-icon>
                </v-btn> -->
                <v-btn 
                    class="mx-1"
					@click="resetAccount(),createdDataFetch()"
                    icon>
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <v-text-field
                        :label="$t('search')"
                        solo
                        v-model="search"
                        hide-details>
                    </v-text-field>
                </v-menu>
				<v-menu
					offset-y>
					<template v-slot:activator="{on}">
						<v-btn
							icon
							v-on="on"
							class="mx-1">
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list width="250" dense>
						<v-list-item
							@click="openAccountDialog({editMode: false})"
							link>
							<v-list-item-icon>
								<v-icon>mdi-database-plus</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('new_account') }}</v-list-item-title>
						</v-list-item>
						<v-divider v-if="selected.chart.length"></v-divider>
						<v-list-item
							v-if="selected.chart.length"
							link>
							<v-list-item-icon>
								<v-icon>mdi-eye</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('show_account') }}</v-list-item-title>
						</v-list-item>
						<v-list-item
							v-if="selected.chart.length"
							:disabled="!selected.chart[0].meta.editable"
							@click="openAccountDialog()"
							link>
							<v-list-item-icon>
								<v-icon :disabled="!selected.chart[0].meta.editable">mdi-pencil</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('edit_account') }}</v-list-item-title>
						</v-list-item>
						<v-list-item
							v-if="selected.chart.length"
							:disabled="!selected.chart[0].meta.deletable"
							@click="openDeleteSingleDialog()"
							link>
							<v-list-item-icon>
								<v-icon :disabled="!selected.chart[0].meta.deletable">mdi-delete</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('delete_account') }}</v-list-item-title>
						</v-list-item>
						
					</v-list>
				</v-menu>
			</v-card-title>
			<v-card-text>
				<v-tabs  class="tab-left" v-model="tab" vertical>
					<v-tab 
						@click="onClickTab(tab), createdDataFetch()" 
						v-for="(tab, i) in tabItem"
						:key="i">
						{{ tab.name }}
					</v-tab>
					<v-tabs-items  v-model="tab">
						<v-tab-item v-for="(tab, i) in tabItem" :key="i">
							<v-row v-on:keydown.ctrl.q.prevent="openMenuList">
								<v-col :cols="selected.chart.length ? 8 : 8">
									<v-subheader class="py-4" light v-if="tabItemData.name">
										{{ tabItemData.name }}
										<v-spacer></v-spacer>
										<div class="mx-0">
										(SDG)	Balance 
										</div>
									</v-subheader>
									<v-divider v-if="tabItemData.name"></v-divider>
									<div v-if="loading.data" class="text-center">
										<v-progress-linear
											indeterminate>
										</v-progress-linear>
									</div>
									<v-treeview
										item-key="id"
										style="cursor: pointer"
										dense
										transition
										activatable
										:active.sync="selected.chart"
										return-object
										:items="accounts[tabItemData.name]">
										<template v-slot:label="{ item }">
											<div  @contextmenu="openMenuList" :class="classFontWeight(item.depth)">{{ item.displayName }}</div>
										</template>
										<template v-slot:append="{ item }">
											<!-- {{ active }} -->
											<span :class="classFontWeight(item.depth)">{{ formatMoney(item.total," ",2) }}</span>
										</template>
									</v-treeview>
								</v-col>
								<v-col v-if="selected.chart.length">
									<!-- <v-data-table
										:headers="header.chart"
										hide-default-footer
										:items="selected.chart">

									</v-data-table> -->
								</v-col>
							</v-row>
						</v-tab-item>
					</v-tabs-items>
				</v-tabs>
			</v-card-text>
        </v-card>
		<context-menu
			v-if="contextMenu.display"
			:position="contextMenu.position"
			:items="contextMenuItems"
			@contextmenu:click="contextMenuClicked">
		</context-menu>
		<AccountDialog
			v-if="accountDialogProps.display"
			:id="accountDialogProps.id"
			@close="closeAccountDialog"
			@submit="createdDataFetch(true)"
			ref="accountDialog"/>
		<RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
		<DeleteSingleDialog
            @close="closeDeleteSingleDialog"
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog"/>
		<SnackbarAlert
			ref="snackbarAlert"/>
			<v-dialog 
				scrollable
				v-model="statementProps.display"
				width="auto">
				<p-statements
					scrollable
					v-if="statementProps.display"
					:showButton="true"
					:statement="statementProps.statement"
					@close="statementProps.display = false"
					>
				</p-statements>
			</v-dialog>
    </div>
</template>
<script>
import DeleteSingleDialog from '@/components/common/DeleteSingleDialog';
import RetryDialog from '../../components/common/RetryDialog';
import AccountDialog from '@/components/accounting/AccountDialog';
import SnackbarAlert from '@/components/common/SnackbarAlert';
import { mapActions, mapState } from 'vuex';
import {formatMoney} from 'accounting';
import moment from 'moment';
import PStatements from '../../components/accounting/PStatements.vue';
import ContextMenu from '../../components/common/ContextMenu.vue';
export default {
    name: "ChartOfAccounts",
    components: {
		AccountDialog,
		RetryDialog,
		DeleteSingleDialog,
		SnackbarAlert,
        PStatements,
        ContextMenu
	},
    data() {
        return {
			tab: null,
			test: false,
			loading: {
				data: false
			},
            contextMenu: {
                display: false,
                position: {
                    x: 0,
                    y: 0,
                }
            },
			selected: {
				chart: []
			},
			statementProps: {
				display: false,
				statement: {
					from: null,
					to: new moment().format("YYYY-MM-DD"),
					account_id: null
				}
			},
			accountDialogProps: {
				id: null,
				display: false
			},
			deleteSingleDialogProps: {
                id: null,
                display: false,
                target: null,
            },
			options: {},
			search: null,
			tabItem: [
				{ id: 1, name: 'ASSETS'},
				{ id: 2, name: 'LIABILITIES'},
				{ id: 3, name: 'EQUITY'},
				{ id: 4, name: 'REVENUES' },
				{ id: 5, name: 'EXPENSES' },
			],
			header: {
				chart: [
					{ text: this.$t('code'), value: 'formatted_code' },
                    { text: this.$t('account'), value: 'name' },
                    { text: this.$t('total'), value: 'total' },
                    { text: this.$t('account_type'), value:'type' }
				]
			},
			tabItemData: {
				name: null,
			},
        };
    },
    computed: {
		...mapState('accounting/account', ["accounts", 'updata']),
		contextMenuItems() {
            return [
                { title: this.$t('show_quick_report'), icon: "mdi-eye", action: "openStatement", disabled: false},
                { title: this.$t("edit_account"), icon: "mdi-pencil", action: "openAccountDialog", disabled: !this.isEditable},
                { title: this.$t('delete_account'), icon: "mdi-delete", action: "openDeleteSingleDialog", disabled: !this.isDeletable}
            ]
		},
		isDeletable() {
            if(!this.getSelected.meta) return false;
            else return this.getSelected.meta.deletable
        },
        isEditable() {
            if(!this.getSelected.meta) return false;
            else return this.getSelected.meta.editable
        },
        getSelected() {
            return this.selected.chart.length == 1 ? this.selected.chart[0] : {};
		},
		id() {
			return this.selected.chart.length ? this.selected.chart[0].id : null;
		},
		balance() {
			return this.selected.chart.length ? this.selected.chart[0].total : null;
		},
		checkBalance() {
			if(this.balance == 0) return false;
			else return true;
		}
	},
	watch: {
		'selected.chart': {
			handler() {
				if(this.selected.chart.length == 0) this.showMenu = false;
			},
			deep: true
		}
	},
	methods: {
		formatMoney,
		...mapActions('accounting/account', ["fetchAccounts", "removeAccount", 'updateAccounts', "resetAccount"]),
		...mapActions('common/snackBar', ["setSnackBars"]),
		async createdDataFetch() {
			try{
				this.loading.data = true;
				let account = this._.hasIn(this.accounts, this.tabItemData.name);
				if(!account) await this.fetchAccounts({ section: this.tabItemData.name});
				this.loading.data = false;
			} catch(error) {
				let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
			}
		},
		onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
		},
		openContextMenu(e) {
            e.preventDefault();
            this.contextMenu.position.x = e.clientX
            this.contextMenu.position.y = e.clientY
            this.contextMenu.display = false;
            this.$nextTick(() => {
                this.contextMenu.display = true;
            });
        },
		openMenuList(e) {
			if(this.selected.chart.length != 0 && this.selected.chart[0].is_active == 1) {
				this.openContextMenu(e);
			}
		},
		contextMenuClicked(action) {
            this[action]();
        },
		classFontWeight(depth) {
			switch(depth) {
				case depth = 1: return 'font-weight-black';
				case depth = 2: return 'font-weight-bold';
				case depth = 3: return 'font-weight-bold';
				case depth = 4: return 'font-weight-medium';
				case depth = 5: return 'font-weight-medium';
			}
		},
		open(params) {
			this.selected.chart = [];
			this.selected.chart.push(params);
		},
		openDeleteSingleDialog() {
			this.$refs.deleteSingleDialog.open({ target:'chartOfAccount', id: this.id });
            this.selected.chart = [];
		},
		onClickTab(params) {
			this.selected.chart = [];
			this.tabItemData.name = params.name;
		},
		onDeleteDialogSubmit(params) {
            if(params.target == 'chartOfAccount') {
                this.removeAccount(params)
                    .then(() => {
                       this.$emit('removeAccount');
                    })
                    .catch((error) => {
                        this.$refs.deleteSingleDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            }
		},
		closeDeleteSingleDialog() {
            this.deleteSingleDialogProps.display = false;
		},
		openStatement() {
			this.statementProps.statement.from = moment().subtract(1, 'month').format("YYYY-MM-DD");
			this.statementProps.statement.account_id = this.id;
			this.statementProps.display = true;
		},
		openAccountDialog() {
			this.accountDialogProps.id = this.id;
			this.accountDialogProps.display = true;
			this.selected.chart = [];
		},
		closeAccountDialog() {
			this.accountDialogProps.display = false;
		}
	},
	created () {
		// this.createdDataFetch();
	},
	updated() {
		this.$on('removeAccount', () => {
			this.closeDeleteSingleDialog();
			this.setSnackBars({color: "success", message: this.$t("records_delete_success")});
		});
	}
};
</script>
<style scoped>
 div.tab-left [role='tab'] {
	justify-content: flex-start;
 }
</style>
